import { type IRunner } from '~/interfaces';
import { type RunOptions } from '~/types';

export class ExclusiveRunner implements IRunner {
  static create(): ExclusiveRunner {
    return new ExclusiveRunner();
  }

  private _pending = new Map<string, Promise<unknown>>();

  constructor() {
    this.run = this.run.bind(this);
  }

  async run<T>(options: RunOptions<T>): Promise<T> {
    const key = JSON.stringify(options.key);
    if (this._pending.has(key)) {
      return this._pending.get(key) as Promise<T>;
    }

    const promise = options.fn();
    this._pending.set(key, promise);

    try {
      return await promise;
    } finally {
      this._pending.delete(key);
    }
  }
}
